import {
  Breadcrumb,
  Flex,
  Layout,
  Menu,
  MenuProps,
  Typography,
  theme,
  Image,
} from "antd";
import Sider from "antd/es/layout/Sider";
import { Content, Footer } from "antd/es/layout/layout";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RobinHeader } from "./Header";
import { useTranslation } from "react-i18next";
import Logo_Default from "../assets/images/logo_default_transparent.svg";
import Logo_White from "../assets/images/logo_white_transparent.svg";
import Logo_Icon from "../assets/images/logo_icon_default.svg";
import { useThemeContext } from "../context/theme/context";
import { IRoute } from "../common/types";

const { Link } = Typography;

type MenuItem = Required<MenuProps>["items"][number];

export function RobinLayout({
  children,
  AppRoutes,
}: {
  AppRoutes: IRoute[];
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const themeContext = useThemeContext();
  const { t } = useTranslation();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  // States
  const [selectedKey, setSelectedKey] = useState<string>(
    window.location.pathname,
  );
  const [isSiderCollapsed, setIsSiderCollapsed] = useState(false);

  // Effects
  useEffect(() => {
    setSelectedKey(window.location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const menuItems: MenuItem[] = AppRoutes.filter(
    (rec) => rec.showInMenu && !rec.asChild,
  ).map((route) => ({
    label: route.label ? t(route.label) : "",
    key: route.path,
    icon: route.icon,
    onClick: () => !route.asParent && navigate(route.path),
    children: route.asParent
      ? AppRoutes.filter(
          (childRoute) =>
            childRoute.asChild && childRoute.path.startsWith(route.path),
        ).map((childRoute) => ({
          label: childRoute.label ? t(childRoute.label) : "",
          key: childRoute.path,
          icon: childRoute.icon,
          onClick: () => navigate(childRoute.path),
        }))
      : undefined,
  }));

  const pathSegments = window.location.pathname
    .split("/")
    .filter((segment) => segment);
  const breadcrumbItems = (
    pathSegments.length ? pathSegments : ["Dashboard"]
  ).map((segment, index) => ({
    title: (
      <Link key={index} href={`/${pathSegments.slice(0, index + 1).join("/")}`}>
        {segment}
      </Link>
    ),
  }));
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={isSiderCollapsed}
        onCollapse={(value: any) => setIsSiderCollapsed(value)}
        theme={themeContext.state.mode}
        breakpoint="lg"
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <Flex align="cetner" justify="center" style={{ padding: "20px" }}>
          <Image
            preview={false}
            src={
              isSiderCollapsed
                ? Logo_Icon
                : themeContext.state.mode === "dark"
                  ? Logo_White
                  : Logo_Default
            }
          />
        </Flex>
        <Menu
          selectedKeys={[selectedKey]}
          defaultSelectedKeys={["1"]}
          theme={themeContext.state.mode}
          mode="inline"
          items={menuItems}
        />
      </Sider>
      <Layout style={{ marginLeft: isSiderCollapsed ? 80 : 200 }}>
        <RobinHeader />
        <Content style={{ padding: "0 16px" }}>
          <Breadcrumb style={{ padding: "16px 0" }} items={breadcrumbItems} />
          <div
            style={{
              padding: 24,
              minHeight: "100%",
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          RobinFood ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
}
